module.exports = __webpack_public_path__ + "static/img/logo_DOAJC_cropped.0f2f3c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newlogos/logo_DOAJC_cropped.png
// module id = 1252
// module chunks = 1